module.exports = __webpack_public_path__ + "static/media/banner2.8dd18e08.jpg";